import { render, staticRenderFns } from "./app-productItem.vue?vue&type=template&id=e338f054"
import script from "./app-productItem.vue?vue&type=script&lang=js"
export * from "./app-productItem.vue?vue&type=script&lang=js"
import style0 from "./app-productItem.vue?vue&type=style&index=0&id=e338f054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports